export function formatString(pattern: string, params: { [id: string]: any }): string {
  return pattern.replace(/\{(.+?)\}/g, function (_, match) {
    if (params.hasOwnProperty(match)) {
      return params[match];
    }
    return _;
  });
}
